/**
 * 部门管理
 */
import React, {Component} from "react";
import BaseComponent from "../../../../base/BaseComponent";
import TreeAndTableLayout from "../../../../components/TreeAndTableLayout/TreeAndTableLayout";
import {generateTreeData} from "../../../../utils";
import DeptTableOperation from "./deptTableOperation/DeptTableOperation";
import DeptListToolBar from "./deptListToolBar/DeptListToolBar";
import "../../style/sysManagement.css";
import {treeForEach, filterForEach} from "../../../../utils";
import DeptAddModal from "./deptAddModal/DeptAddModal";
import {message} from "../../utils/sysManagementUtils";
import ContentWrap from "../../components/ContentWrap";

export default class DeptList extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            // 树组件
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },

            treeData: [],
            selectedKeys: [],
            expandedKeys: [],
            autoExpandParent: true,

            // 搜索
            searchValue: "",

            // 分页
            pageSize: 10,
            currentPage: 1,
            count: 0,

            //表格
            columns: [],
            tableData: [],
            tableIsLoading: false,

            deptAddModalVisible: false,
            editData: null,
            fid: ""
        };
    }

    componentDidMount() {
        this.getDeptTree();
        this.getColumns();
        this.deptConditionQuery();
    }

    render() {
        const {
            treeData,
            selectedKeys,
            expandedKeys,
            autoExpandParent,

            pageSize,
            currentPage,
            count,

            columns,
            tableData,
            tableIsLoading,

            searchValue,
            deptAddModalVisible,
            editData,
            fid
        } = this.state;
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    showSearch={false}
                    treeData={treeData}
                    onSelect={this.onTreeSelect}
                    onExpand={this.onExpand}
                    showIcon={true}
                    selectedKeys={selectedKeys}
                    expandedKeys={expandedKeys}
                    autoExpandParent={autoExpandParent}
                    tableData={tableData}
                    pageSize={pageSize}
                    current={currentPage}
                    count={count}
                    columns={columns}
                    tableIsLoading={tableIsLoading}
                    defaultLayout={"userDeptTree"}
                    ToolBar={
                        <DeptListToolBar
                            searchValue={searchValue}
                            onSearch={this.onSearch}
                            selectedKeys={selectedKeys}
                            onSearchValueChange={this.onSearchValueChange}
                            updateTable={() => {
                                this.deptConditionQuery();
                                this.getDeptTree();
                            }}
                            expandKey={this.expandKey}
                            showEditModal={() => this.showEditModal(null, selectedKeys[0])}
                        />
                    }

                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                />

                <DeptAddModal
                    title={editData ? "修改部门" : "添加部门"}
                    visible={deptAddModalVisible}
                    handleOk={this.submitEditModal}
                    handleCancel={this.hideEditModal}
                    data={editData}
                    fid={fid}
                />
            </ContentWrap>
        );
    }

    submitEditModal = dept => {
        message.destroy();
        if (dept.id) {
            this.deptEdit(dept);
        } else {
            this.deptAdd(dept);
        }
    };

    hideEditModal = () => {
        this.setState({
            deptAddModalVisible: false
        });
    };

    showEditModal = (editData, fid) => {
        this.setState({
            deptAddModalVisible: true,
            editData,
            fid
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    expandKey = key => {
        const {expandedKeys, treeData} = this.state;
        const tree = filterForEach(treeData, node => {
            return node.id === key;
        });
        const keys = [];
        treeForEach(tree, node => {
            keys.push(node.id);
        });
        this.setState({
            expandedKeys: [...(new Set([...expandedKeys, ...keys]))],
            autoExpandParent: false
        });
    };

    onTreeSelect = (selectKeys) => {
        this.setState({
            selectedKeys: selectKeys,
            currentPage: 1,
            searchValue: ""
        }, () => {
            this.deptConditionQuery();
        });
    };

    onSearch = () => {
        this.setState({
            currentPage: 1
        }, () => {
            this.deptConditionQuery();
        });
    };

    onSearchValueChange = searchValue => {
        this.setState({searchValue});
    };

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page,
            pageSize: pageSize
        }, () => {
            this.deptConditionQuery();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = (current, size) => {
        this.setState({
            pageSize: size,
            currentPage: 1
        }, () => {
            this.deptConditionQuery();
        });
    };

    // 请求树数据
    getDeptTree = () => {
        const {selectedKeys} = this.state;
        this.deptGetTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData([res], this.state.treeDataIndex);
            // 首次请求设置激活的树id  并展开所有的树
            if (!selectedKeys.length) {
                const expandedKeys = [];
                treeForEach(treeData, node => {
                    if (node.children && node.children.length) {
                        expandedKeys.push(node.id);
                    }
                });
                this.setState({
                    selectedKeys: [treeData[0].id],
                    expandedKeys,
                    treeData
                });
            }
            this.setState({
                treeData
            });
        });
    };

    deptConditionQuery = () => {
        const {pageSize: size, currentPage: page, searchValue: nameOrCode = "", selectedKeys} = this.state;
        const id = selectedKeys[0];
        const params = {
            id, nameOrCode, page, size
        };
        this.setState({
            tableIsLoading: true
        });
        this.deptConditionQueryRequest(params, res => {
            const {count} = res.data.count;
            if (count !== 0 && count <= (page - 1) * size) {
                this.onPageChange(page - 1, size);
            } else {
                this.setState({
                    tableData: res.data.data,
                    count: res.data.count,
                    tableIsLoading: false
                });
            }

        });
    };

    getColumns = () => {
        const columns = [
            {
                title: "部门名称",
                dataIndex: "name",
                ellipsis: true,
                render: (text, record) => {
                    return <span onClick={() => this.onTreeSelect([record.id])}  style={{color:'#0050B3',cursor: 'pointer'}}>{text}</span>;
                }
            },
            {
                title: "上级部门",
                ellipsis: true,
                dataIndex: "fDept.name"
            },
            {
                title: "操作",
                width: 260,
                render: (text, record) => {
                    return <DeptTableOperation
                        data={record}
                        showEditModal={(record, fid) => this.showEditModal(record, fid)}
                        updateData={this.updateData}/>;
                }
            }
        ];
        this.setState({
            columns
        });
    };

    updateData = ({fid} = {}) => {
        this.deptConditionQuery();
        this.getDeptTree();
        if (fid) {
            this.expandKey(fid);
        }
    };

    deptAdd = dept => {
        this.deptAddRequest(dept, res => {
            if (res) {
                message.success("部门添加成功");
                this.setState({
                    currentPage: 1
                }, () => {
                    this.deptConditionQuery();
                    this.getDeptTree();
                    this.expandKey(dept.fid);
                    this.hideEditModal();
                });
            }
        });
    };

    deptEdit = (data) => {
        this.deptEditRequest(data, res => {
            if (res) {
                message.success("部门修改成功");
                this.deptConditionQuery();
                this.getDeptTree();
                this.hideEditModal();
                this.expandKey(data.id);
            }
        });
    };

//   接口部分///////////////////////////////////////////////////////////////////////////////
    /**
     * 获取部门树
     * @param callBack
     */
    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack
        });
    };

    /**
     *
     * @param id
     * @param nameOrCode
     * @param page
     * @param size
     * @param ifContainSonDept  默认包含子部门
     * @param callBack
     */
    deptConditionQueryRequest = ({id = "0", nameOrCode, page, size, ifContainSonDept = 1} = {}, callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getAllChildDeptListBydeptFindPojo",
            body: {id, nameOrCode, page, size, ifContainSonDept},
            method: "post",
            contentType: "json",
            callBack
        });
    };

    deptAddRequest = ({fid, name, status, tel, deptOrder}, callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/add",
            body: {fid, name, status, tel, deptOrder},
            method: "post",
            contentType: "json",
            callBack
        });
    };


    deptEditRequest = ({id, fid, name, tel, status, deptOrder}, callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/update",
            body: {id, fid, name, tel, status, deptOrder},
            method: "post",
            contentType: "json",
            callBack
        });
    };
}
